import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TbsButtonModule } from '@ngx-terabase/ui/button';
import { TbsDialogModule } from '@ngx-terabase/ui/dialog';
import { TbsUploadChangeEvent } from '@ngx-terabase/ui/upload';
import {
  FileTreeNodeComponent,
  TreeNode,
} from 'src/app/components/file-tree-node/file-tree-node.component';

@Component({
  selector: 'app-upload-structure-dialog',
  imports: [
    CommonModule,
    TbsDialogModule,
    MatDialogModule,
    TbsButtonModule,
    FileTreeNodeComponent,
  ],
  templateUrl: './upload-structure-dialog.component.html',
  styleUrl: './upload-structure-dialog.component.scss',
  standalone: true,
})
export class UploadStructureDialogComponent implements OnInit {
  private data = inject(MAT_DIALOG_DATA);
  public treeData: TreeNode[] = [];

  ngOnInit(): void {
    const files: TbsUploadChangeEvent = this.data.files;

    this.treeData = this.buildTree(files.map((file) => file.filePath));
  }

  private buildTree(paths: string[]): TreeNode[] {
    const root: TreeNode[] = [];

    for (const path of paths) {
      const parts = path.split('/');
      let currentLevel = root;

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        let existing = currentLevel.find((n) => n.name === part);

        if (!existing) {
          existing = {
            name: part,
            ...(i < parts.length - 1 ? { children: [], expanded: false } : {}),
          };
          currentLevel.push(existing);
        }

        if (existing.children) {
          currentLevel = existing.children;
        }
      }
    }

    return root;
  }
}
